import { Component, OnInit, ViewChild,  ChangeDetectorRef } from '@angular/core';
import { DxDropDownBoxComponent, DxFormComponent, DxTreeViewComponent } from "devextreme-angular";

import { HttpClient } from '@angular/common/http';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { v4 as uuid } from "uuid";

import { ActivatedRoute } from "@angular/router";



import { Observable, BehaviorSubject } from 'rxjs';

import { Location } from '@angular/common'
import { MainModel } from 'src/app/models/auth/_models/main-model';
import { MicroApplication, Widget } from 'src/app/services/microapplications/_models/microapplication.model';
import { Menu } from 'src/app/models/menu';
import { IconsFontAwesome } from 'src/app/services/microapplications/_models/const';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { MainService } from 'src/app/services/shared/main.service';
import { LayoutService } from 'src/app/models/auth/_services/layout.service';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { MessagesService } from 'src/app/services/service.index';
@Component({
  selector: "app-microapplication-settings",
  templateUrl: "./microapplication-settings.component.html",
  styleUrls: ["./microapplication-settings.component.scss"],
})
export class MicroapplicationSettingsComponent implements OnInit {
  formId = uuid();
  @ViewChild(DxFormComponent, { static: false }) myform: DxFormComponent;
  @ViewChild('dropDownTreeView', { static: false }) dropDownTreeView: DxDropDownBoxComponent;
  @ViewChild('dropDownBoxIcon', { static: false }) dropDownBoxIcon: DxDropDownBoxComponent;
  @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;
  isSearching = true;
  mainDataSearch: MainModel[] = [];
  microapplication: MicroApplication = new MicroApplication();
  microApploaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingObserver: Observable<boolean>;
  loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  main: MainModel = new MainModel();
  microApplicationsTypes: { name: string; id: number }[];
  listActions: Menu[];
  gridBoxValue: number[] = [3];
  DropBoxValue: number[] = [3];
  gridDataSource: any;
  isDropDownBoxOpened = false;
  ulCSSClasses: string;
  backOptions: any;
  saveButtonOptions: any;
  editMode = false;
  insertMode = false;
  itemsOrder: any[] = [];
  icons = new DataSource({
    store: {
      type: "array",
      key: "value",
      data: IconsFontAwesome.map((i) => {
        return { value: i, name: i };
      }),
    },
  });
  createChildren: any;
  constructor(
    private httpClient: HttpClient,
    public microApps: MicroapplicationService,
    private activatedRoute: ActivatedRoute,
    public mainService: MainService,
    private layout: LayoutService,
    private mainHttp: MainHTTPService,
    private changeDetectorRef: ChangeDetectorRef,
    private _messagesService: MessagesService,
    private location: Location,
    private microApplicationService: MicroapplicationService) {
    this.gridDataSource = this.makeAsyncDataSource(
      this.httpClient,
      JSON.stringify(IconsFontAwesome)
    );

    this.backOptions = {
      icon: "undo",
      hint: "Atrás",
      onClick: () => {
        this.goback();
      },
    };

    this.saveButtonOptions = {
      icon: "save",
      hint: "Guardar",
      onClick: () => {
        this.save();
      },
    };
    this.createChildren = (parent) => {
      const parentId = parent ? parent.itemData.id : 0;
      return this.mainService.loadMenu(parentId).toPromise();
    };


    this.loadingObserver = this.loadingSubject.asObservable();

    this.microApplicationsTypes = [{ name: 'Programa', id: 0 }, { name: 'Widget', id: 1 },{ name: 'Dashboard', id: 2 }];
  }


  onInitialized(e) {
    e.component.option("openOnFieldClick", false);
  }
  onRowClick(e) {
    this.microapplication.icon = e.data.value;
    this.dropDownBoxIcon.instance.close();
  }
  save() {
    let result = this.myform.instance.validate();

    if (result.isValid) {
      this.microApps.loadingSubject.next(true);
      if (this.insertMode) {
        this.microApps.postMicroApplication(this.microapplication).subscribe(result => {
          if (result.isSuccessful) {
            if (this.microapplication.type == 0) {
              this.mainHttp.updateMainApplicationId(this.main.id, this.microapplication.id).subscribe((resp) => {
                this.microApps.loadingSubject.next(false);
                if (resp.isSuccessful) {
                  this._messagesService.success('Hecho!')
                }
              }, err => { this.microApps.loadingSubject.next(false); });
            }
            else {
              this._messagesService.success('Hecho!')
            }

          }
        }, err => { this.microApps.loadingSubject.next(false); });
      }
      if (this.editMode) {
        this.microApps.loadingSubject.next(true);
        this.microApps.updateMicroApplication(this.microapplication).subscribe(result => {
          if (result.isSuccessful) {
            if (this.microapplication.type == 0) {
              this.mainHttp.updateMainApplicationId(this.microapplication.applicationMenu.id, this.microapplication.id).subscribe((resp) => {
                if (resp.isSuccessful) {
                  this._messagesService.success('Hecho!')
                }
                this.microApps.loadingSubject.next(false);
              }), err => { this.microApps.loadingSubject.next(false); };
            }
            else {
              this._messagesService.success('Hecho!')
            }
          }
        }, err => {
          this.microApps.loadingSubject.next(false);
        });
      }
    }
  }

  setTags(e) {
    this.microapplication.tags = e.value;
  }
  gridHeight = () => {
    return Math.round(window.innerHeight / 1);
  };
  goback() {
    // this.router.navigate(["microapplication/microapplication-list"]);
    this.location.back();
  }
  ngOnInit() {
    this.getWidgets();
    this.lookForDataMenu();
    this.ulCSSClasses = this.layout.getProp("aside_menu_nav");
    this.activatedRoute.queryParams.subscribe((params) => {
      const id = params.pId;
      if (id) {
        this.editMode = true;
        this.loadMicroApplicationById(id);
      } else {
        this.insertMode = true;
        this.microApploaded.next(true);
      }
    });
  }

  loadMicroApplicationById(id: any) {
    this.microApps.GetMicroApplicationsById(id).subscribe((resp) => {
      this.microApploaded.next(true);
      this.microApps.loading = false;
      if (resp.isSuccessful) {
        this.microapplication = resp.result;
        if (!this.microapplication.widgetData)
          this.microapplication.widgetData = new Widget();

        this.loadMainMenu();
      }
    });
  }


  loadMainMenu() {
    this.microapplication.applicationMenu = new MainModel();
    this.mainHttp.getMainMenu(this.microapplication.id).subscribe(resp => {
      this.microApploaded.next(true);
      if (resp.isSuccessful && resp.result != null) {

        this.microapplication.applicationMenu = resp.result;

      }
    })
  }


  changeDropDownBoxValue = function (args) {
    this.isDropDownBoxOpened = false;
  };

  async redirect() { }
  makeAsyncDataSource(http, jsonFile) {
    return new CustomStore({
      loadMode: "raw",
      key: "ID",
      load() {
        return http.get(jsonFile).toPromise();
      },
    });
  }

  gridBox_displayExpr(item) {

    return item;
  }

  gridBox_displayExprMenu(item) {
    return item;
  }

  visibleChanged($event) {
    this.microapplication.visible = $event.value;
  }

  instanceChanged($event) {
    this.microapplication.multiInstance = $event.value;
  }

  onCategoryTreeViewSelectionChanged = (e: any) => {

    if (e.itemData.hasItems) {
      if (e.itemData.expanded) {
        this.treeView.instance.collapseItem(e.itemData);
      }
      else
        this.treeView.instance.expandItem(e.itemData);
    }
    else {
      this.microapplication.applicationMenu = e.itemData;
      this.dropDownTreeView.instance.close();
    }


  };

  setMenuBySearch(e) {
    if (!e.hasItems) {

      this.microapplication.applicationMenu = e;
      this.dropDownTreeView.instance.close();
    }

  }
  close() {
    this.treeView.instance.collapseAll();
  }


  lookForDataMenu() {
    this.mainService.main.asObservable().subscribe((resp) => {
      this.mainDataSearch = resp;
    });
  }



  closeNodes() {
    this.treeView.instance.collapseAll();
  }



  getMainBySearchBar(data: string) {
    this.mainService.loadMenuFilter(data).toPromise().then((data) => {
      this.isSearching = false;
      let e = { code: 'Enter' };
      this.changeDetectorRef.detectChanges();
      this.handlePropertyChange(null, e);
    })
  }


  handlePropertyChange(event, e) {

    if (e.code === "Enter") {
      if (event != null && event.length > 0) {
        this.getMainBySearchBar(event);

      }
    }

    if (event != null && event.length === 0) {
      this.isSearching = true;
    }
  }

  getWidgets() {
    this.microApplicationService.GetWidgets().subscribe(resp => {
      if (resp.isSuccessful && resp.result != null) {

        for (let i = 0; i <= resp.result.length; i++) {
          if(resp.result.filter(p => p.widgetData.order == i).length == 0 ){
            this.itemsOrder.push(i);
          }
  
        }

      }
    })
  }
}
